<mat-toolbar>
  <div class="d-flex h-100 w-100 align-items-center justify-content-between">
    <div class="h-100 d-flex gap-2 align-items-center">
      @if ((responsiveService.isMobileScreen$ | async) === true) {
        <img
          class="h-75 cursor--pointer"
          src="/logo-stamp.png"
          alt="Stichting Wijkcollectie"
          routerLink="/"
        >
        <a
          href="https://wijkcollectie.nl"
          target="_blank"
          rel="noopener noreferrer"
          mat-mini-fab
          aria-label="WijkCollectie website"
        >
          <mat-icon fontSet="material-symbols-outlined" class="text-primary">home</mat-icon>
        </a>
      } @else {
        <img
          class="h-75 cursor--pointer"
          src="/Logo-SW-small-peach-white-scaled.png"
          alt="Stichting Wijkcollectie"
          routerLink="/"
        >
        <a href="https://wijkcollectie.nl" target="_blank" rel="noopener noreferrer" matButton="outlined"
           class="danger-button">
          <mat-icon fontSet="material-symbols-outlined">home</mat-icon>
          wijkcollectie.nl
        </a>
      }
    </div>

    @if ((responsiveService.isMobileScreen$ | async) === false && (responsiveService.isTabletScreen$ | async) === false) {
      <div class="app-title flex justify-center">
        <div class="text-center" style="line-height: 0.7;">
          <h2 class="m-0 p-0 arbutus" style="font-size: 1.125rem;">Wijkcollectie</h2>
          <span style="font-size: 14px;font-weight: 300;">Verhalen van bewoners uit Rotterdamse wijken.</span>
        </div>
      </div>
    }

    <div class="d-flex gap-2">
      @if ((responsiveService.isMobileScreen$ | async) === true) {
        <button
          (click)="openFiltersSheet()"
          mat-mini-fab
          aria-label="Filteren"
        >
          <mat-icon fontSet="material-symbols-outlined" class="text-primary">filter_alt</mat-icon>
        </button>
      }


      @if ((responsiveService.isMobileScreen$ | async) === false) {
        <button routerLink="/story-map" matButton="outlined" class="danger-button">
          <mat-icon>location_on</mat-icon>
          Kaart
        </button>
      } @else {
        <button
          mat-mini-fab
          aria-label="Kaart"
          routerLink="/story-map"
          routerLinkActive="fab-active"
        >
          <mat-icon fontSet="material-symbols-outlined" class="text-primary">location_on</mat-icon>
        </button>
      }

      @if ((responsiveService.isMobileScreen$ | async) === false) {
        <button routerLink="/story-list" matButton="outlined" class="danger-button">
          <mat-icon>list</mat-icon>
          Lijst
        </button>
      } @else {
        <button
          mat-mini-fab
          aria-label="Lijst"
          routerLink="/story-list"
          routerLinkActive="fab-active"
        >
          <mat-icon fontSet="material-symbols-outlined" class="text-primary">list</mat-icon>
        </button>
      }

      @if ((responsiveService.isMobileScreen$ | async) === false) {
        <a
          href="https://wijkcollectie.wanderandwonder.ai/?chat="
          target="_blank"
          rel="noopener noreferrer"
          matButton="outlined"
          class="danger-button"
        >
          <mat-icon>chat_bubble</mat-icon>
          Chat
        </a>
      } @else {
        <a
          href="https://wijkcollectie.wanderandwonder.ai/?chat="
          target="_blank"
          rel="noopener noreferrer"
          mat-mini-fab
          routerLinkActive="fab-active"
        >
          <mat-icon fontSet="material-symbols-outlined" class="text-primary">chat_bubble</mat-icon>
        </a>
      }
    </div>
  </div>
</mat-toolbar>

@if (showFilterHeader$ | async) {
  <mat-toolbar class="secondary-toolbar">
    <div
      class="w-100 d-flex gap-2 my-2"
      [class]="(responsiveService.isLargeDesktopScreen$ | async) === true ? 'flex-row': 'flex-column'"
    >
      <div
        class="w-100 d-flex flex-row gap-2"
        [ngClass]="{'flex-column': ['tablet','mobile'].includes((responsiveService.currentBreakpoint$ | async) ?? '')}"
      >

        <div class="flex-1">
          <!-- Search -->
          <mat-form-field appearance="outline" class="w-100 no-subscript search-form-field">
            <mat-label>Zoek in titel, nummer, beschrijving...</mat-label>
            <input [formControl]="searchQueryInput" matInput placeholder="Zoek in titel, nummer, beschrijving" value="">
          </mat-form-field>
        </div>


        <div
          class="d-flex flex-row gap-2"
          [ngClass]="{'flex-column': responsiveService.isMobileScreen$ | async}"
        >
          <!-- Neighbourhood -->
          <mat-form-field appearance="outline" class="no-subscript">
            <mat-label>Wijk</mat-label>
            <mat-select [formControl]="neighbourhoodSelect" multiple>
              @for (neighbourhood of neighbourhoodList; track neighbourhood.id) {
                <mat-option [value]="neighbourhood">{{ neighbourhood.name }}</mat-option>
              }
            </mat-select>
          </mat-form-field>

          <!-- Theme -->
          <mat-form-field appearance="outline" class="no-subscript">
            <mat-label>Thema</mat-label>
            <mat-select [formControl]="storyThemeSelect" multiple>
              @for (storyTheme of storyThemeList; track storyTheme.id) {
                <mat-option [value]="storyTheme">{{ storyTheme.name }}</mat-option>
              }
            </mat-select>
          </mat-form-field>

          <!-- Tag -->
          <mat-form-field appearance="outline" class="no-subscript">
            <mat-label>Trefwoord</mat-label>
            <mat-select [formControl]="tagSelect" multiple>
              @for (tag of storyTagList; track tag.id) {
                <mat-option [value]="tag">{{ tag.name }}</mat-option>
              }
            </mat-select>
          </mat-form-field>

        </div>
      </div>

      <div class="d-flex gap-2">
        <!-- Story type filter -->
        <mat-button-toggle-group [formControl]="storyTypeInput" hideSingleSelectionIndicator name="fontStyle" aria-label="Story type filter">
          <mat-button-toggle value="all">Alles</mat-button-toggle>
          <mat-button-toggle value="stories">Verhalen</mat-button-toggle>
          <mat-button-toggle value="projects">Projecten</mat-button-toggle>
        </mat-button-toggle-group>

        <!-- Active filter -->
        <mat-button-toggle-group [formControl]="activeInput" hideSingleSelectionIndicator name="fontStyle" aria-label="Active filter">
          <mat-button-toggle value="all">Alles</mat-button-toggle>
          <mat-button-toggle value="active">Actief</mat-button-toggle>
          <mat-button-toggle value="non-active">Niet actief</mat-button-toggle>
        </mat-button-toggle-group>

        <!-- Reset -->
        <div class="d-flex align-items-center">
          <button mat-stroked-button (click)="clearFilters()">Wis filters</button>
        </div>
      </div>

    </div>
  </mat-toolbar>
}
<div
  class="app-progress-bar"
  [ngClass]="{
  'app-progress-bar__mobile': (responsiveService.isMobileScreen$ | async) === true
  }"
>
  @if (appStateStore.loading$ | async) {
    <mat-progress-bar
      mode="indeterminate"
    ></mat-progress-bar>
  }
</div>

<div
  class="main-content"
  [ngClass]="{
  'main-content__tablet': (responsiveService.isTabletScreen$ | async) === true,
  'main-content__no-sub-header': (showFilterHeader$ | async) === false,
  'main-content__no-sub-header__mobile': (responsiveService.isMobileScreen$ | async) === true
  }"
>
  <router-outlet></router-outlet>
</div>
